import {
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  computed,
  input,
  output
} from '@angular/core';

import { IrisIconButtonTypes } from '@sondermind/iris/icon-button';

import { IrisModalDismissReason } from '../utilities/iris-modal-dismiss-reason';

/**
 * This component handles the shared display logic of the content of modals, excluding the UnstyledFullscreenModal.
 */
@Component({
  selector: 'iris-modal-chrome',
  templateUrl: './modal-chrome.component.html',
  styleUrls: ['./modal-chrome.component.scss'],
  standalone: false
})
export class IrisModalChromeComponent {
  readonly title = input<string>('');
  readonly showTitle = input<boolean>(true);
  readonly ariaLabel = input<string>('');
  readonly showHeader = input<boolean>(true);
  readonly isDismissable = input<boolean>(true);
  readonly closeOnBackdropClick = input<boolean>(false);
  readonly customStyles = input<Record<string, string>>({});

  readonly dismissRequested = output<IrisModalDismissReason>();

  @HostBinding('style')
  get hostStyles(): Record<string, string> {
    return this.customStyles();
  }

  readonly irisIconButtonTypes = IrisIconButtonTypes;

  readonly effectiveAriaLabel = computed(() => {
    if (this.showTitle() && this.title().trim().length > 0) {
      return '';
    }
    return this.ariaLabel().trim() || 'Dialog';
  });

  constructor(private readonly hostElement: ElementRef<HTMLElement>) {}

  onDismissRequested(): void {
    this.dismissRequested.emit('closeButton');
  }

  @HostListener('document:keyup.escape')
  escKeyPressed(): void {
    if (this.isDismissable() || this.closeOnBackdropClick()) {
      this.dismissRequested.emit('escape');
    }
  }

  @HostListener('document:click', ['$event'])
  onBackdropClick(event: Event): void {
    if (this.closeOnBackdropClick()) {
      const target = event.target as HTMLElement;
      if (!this.hostElement.nativeElement.contains(target)) {
        this.dismissRequested.emit('backdropDocumentClick');
      }
    }
  }
}
